import React from 'react'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import shortid from 'shortid'
import get from 'lodash/get'
import { FONTS } from '../../../../constants'

const generateSumHours = (selectedDateProjects) => {
  const sumHours = []
  const run = moment(selectedDateProjects).startOf('month')
  const endDate = moment(selectedDateProjects).endOf('month')
  while (run.isBefore(endDate, 'day') || run.isSame(endDate, 'day')) {
    sumHours[run.format('YYYY-MM-DD')] = 0
    run.add(1, 'days')
  }
  return sumHours
}

const sumTotalMD = (timesheetProjects) => {
  let sum = 0
  timesheetProjects.map(user => {
    if (user.sumMd) {
      sum += parseFloat(user.sumMd)
    }
    return user
  })
  return sum
}


const sumTotalWMD = (timesheetProjects) => {
  let sum = 0
  timesheetProjects.map(user => {
    if (user.sumWmd) {
      sum += parseFloat(user.sumWmd)
    }
    return user
  })
  return sum
}

const sumTotalHours = (timesheetProjects) => {
  let sum = 0
  timesheetProjects.map(user => {
    if (user.sumHours) {
      sum += parseFloat(user.sumHours)
    }
    return user
  })
  return sum
}

const sumTotalHoursByDate = (timesheetProjects, date) => {
  let sum = 0
  timesheetProjects.map(user => {
    if (user.sumHoursByDate) {
      sum += user.sumHoursByDate[date]
    }
    return user
  })
  return sum
}

const fallbackNan = (sum) => {
  return sum === 'NaN' ? 0 : sum
}

export const HourRow = (props) => {
  const dates = generateSumHours(moment(get(props, 'selectedDateProjects'), 'MM/YYYY').format('YYYY-MM'))
  const timesheetProjects = get(props, 'timesheetByProjects.timesheets', [])
  const totalHours = sumTotalHours(timesheetProjects)
  const totalWMD = sumTotalWMD(timesheetProjects)
  const totalMD = sumTotalMD(timesheetProjects)

  return (
    <Wrapper>
      <HourText>Hourly per day</HourText>
      <Column>
        <Total>{ parseFloat(totalHours).toFixed(2) }</Total>
        <Total>{ parseFloat(totalMD).toFixed(2) }</Total>
        <Total>{ parseFloat(totalWMD).toFixed(2) }</Total>
        {Object.keys(dates).map(date => {
          const sum = sumTotalHoursByDate(timesheetProjects, date)
          return (
            <Cell key={ shortid() }>
              <Date>{ fallbackNan(sum) }</Date>
            </Cell>
          )
        })}
      </Column>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: #EEEEEE ;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`
const Column = styled.div`
  height: 100%;
  background-color: #EEEEEE;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Cell = styled.div`
  font-size: 12px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: solid #EAEAEA;
  border-width: 0px 1px 0px 0px;
`
const Date = styled.div`
  color: black;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const HourText = styled.div`
  width: 200px;
  margin-left: 2% !important;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
`
const Total = styled.span`
  width: 50px;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/timesheet-by-project/hour-row.js